export const LangEn = {
    name:'en',
    data:{
        "modalExp":{
            "name":"kd,mkdmdké"
        },
        "name":'Ceci est un test',
        "missionCreation": {
            "confirmation": {
                "title": "Confirmation",
                "description": "Check the mission details before creating it.",
                "motif": "Reason",
                "period": "Mission period",
                "invitations": "Invitations",
                "template": "Job description",
                "editMotif": "Edit the reason",
                "editPeriod": "Edit the period",
                "editInvitations": "Edit the invitations",
            },
        },
        "missionTemplate": {
            "tools": {
                "provider": {
                    "company": "Company",
                    "temp_worker": "Temp worker",
                },
                "addPlaceholder": "Select",
                "addLabel": "Add equipment",
                "noOptions": "No equipment available",
                "providerSelectLabel": "Provider",
                "removeLabel": "Remove",
            },
            "steps": {
                "activity": "Business sector",
                "riskyPosition": "High-risk position",
                "prerequis": "Prerequisites",
                "locationSalary": "Location & Pay",
                "info": "Additional info",
                "confirmation": "Confirmation",
            },
            "riskyPosition": {
                "title": "High-risk position",
                "description": "Specify whether this position exposes the temp worker to particular risks.",
                "question": "Is this position on the list of high-risk positions?",
                "articleLink": "See article L. 4154-2",
                "listLabel": "High-risk positions concerned",
                "empty": "No high-risk position available",
                "loadError": "Could not load the list of high-risk positions. Please try again later.",
                "selectionRequired": "Please select at least one high-risk position",
                "summaryNo": "No",
                "summaryYes": "Yes",
            },
            "confirmation": {
                "edit": "Edit",
            },
            "list": {
                "searchPlaceholder": "Search",
                "searchLabel": "Search a job template",
                "create": "Job template",
                "loading": "Loading job templates…",
                "noResult": "No job template matches your search.",
                "perHour": "/h",
                "belowMinimumWage": "Below the minimum wage: update the template before creating a mission.",
            },
            "preview": {
                "defaultTitle": "Job template",
                "closeLabel": "Close the preview",
                "close": "Close",
                "edit": "Edit",
                "delete": "Delete",
                "use": "Use this template",
                "belowMinimumWage": "Hourly rate below the minimum wage: edit the template to use it.",
                "fields": {
                    "name": "Template title",
                    "activity": "Sector",
                    "qualification": "Qualification",
                    "tools": "Equipment",
                    "licences": "Licences",
                    "languages": "Language",
                    "riskyPosition": "High-risk position",
                    "address": "Address",
                    "salary": "Gross hourly rate",
                    "contact": "Manager",
                    "other": "Temp worker note",
                    "otherInterim": "Agency note",
                },
            },
        },
        map : new Map()
    }
}